import { Body, Controller, Post } from '@nestjs/common';
import { ApiBody } from '@nestjs/swagger';
import { DayMonthPoOperationSummaryResponse, GlobalResponseObject, OpCategoryWiseSummaryQtyResponse, UnitResponse } from '@shahi-analytics/shared-models';
import { UnitDayHourMinuteRequest } from '../migration/models/unit-day-hour-minute.request';
import { GtsService } from './gts.service';

@Controller('gts')
export class GtsController {
  constructor(private readonly gtsService: GtsService) { }

  /**
   * 
   * @param req 
   * @returns 
   */
  @ApiBody({type: UnitDayHourMinuteRequest})
  @Post('/getScheduleWiseOpSummary')
  async getScheduleWiseOpSummary(@Body() req: any): Promise<DayMonthPoOperationSummaryResponse> {
    try {
      return await this.gtsService.getScheduleWiseOpSummary(req.unit, req.date);
    } catch(error) {
      console.log(error);
      return new GlobalResponseObject(false, 0, error?.toString());
    }
  }


  /**
   * 
   * @param req 
   * @returns 
   */
  @ApiBody({type: UnitDayHourMinuteRequest})
  @Post('/getOpCategoryWiseSummaryQtysTillDate')
  async getOpCategoryWiseSummaryQtysTillDate(@Body() req: any): Promise<OpCategoryWiseSummaryQtyResponse> {
    try {
      return await this.gtsService.getOpCategoryWiseSummaryQtysTillDate(req.unit, req.date);
    } catch(error) {
      console.log(error);
      return new GlobalResponseObject(false, 0, error?.toString());
    }
  }



  @Post('/getGtsEnabledUnits')
  async getGtsEnabledUnits(): Promise<UnitResponse> {
    try {
      return await this.gtsService.getGtsEnabledUnits();
    } catch(error) {
      console.log(error);
      return new GlobalResponseObject(false, 0, error?.toString());
    }
  }

}